import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./temperature_section.module.css";
import {
  getTemperatureScale,
  hasTemperatureReading,
  numberToLetter,
  temperatureToHex,
} from "../../../../../utils/utils";

function Temperature({ item }) {
  return (
    <div className={"d-flex align-items-center"}>
      <div
        className={styles.temperature}
        style={{ backgroundColor: item.hex }}
      />
      <div>{item.value}°C</div>
    </div>
  );
}

function TemperatureIndicator({
  coords,
  hex,
  zone,
  selectedZone,
  setSelectedZone,
}) {
  return (
    <div
      className={styles.outerIndicator}
      style={{
        top: `calc(${coords.y}% - 20px)`,
        left: `calc(${coords.x}% - 20px)`,
        background:
          zone === selectedZone
            ? "radial-gradient(#FFF 20%, #FFF4 86%, #FFF0 90%)"
            : "transparent",
      }}
    >
      <div
        className={styles.indicator}
        style={{
          backgroundColor: hex + "66",
        }}
      >
        <div
          className={styles.innerIndicator}
          style={{
            backgroundColor: hex,
          }}
        />
      </div>
    </div>
  );
}

export default function TemperatureSection({ pduiData }) {
  const { t } = useTranslation();
  const [selectedZone, setSelectedZone] = useState(-1);

  return (
    <div className={styles.container}>
      <div className={styles.heatmap}>
        <div className={styles.legend}>
          <div
            className={
              "d-flex justify-content-between align-items-start flex-column h-100"
            }
          >
            {getTemperatureScale().map((item, index) => (
              <Temperature key={index} item={item} />
            ))}
          </div>
        </div>
        <div className={styles.map}>
          <img
            src={`/pduis/${pduiData?.model?.image_name}/pdui_board.png`}
            alt={"pdui"}
            height={"263px"}
          />
          {pduiData.temperatures.temperatures.map((temperature, index) => (
            <TemperatureIndicator
              zone={index}
              selectedZone={selectedZone}
              setSelectedZone={setSelectedZone}
              hex={temperatureToHex(temperature)}
              coords={pduiData?.model?.temperature_data[index]}
            />
          ))}
        </div>
      </div>
      <div className={styles.table}>
        <table>
          <thead>
            <tr>
              <th>{t('temperature.name')}</th>
              <th>{t('temperature.zone')}</th>
              <th>{t('temperature.temperature')}</th>
            </tr>
          </thead>
          <tbody>
            {pduiData.temperatures.temperatures.map((temperature, index) => (
              <tr
                key={index}
                onClick={() => {
                  setSelectedZone(index);
                }}
              >
                <td>{numberToLetter(index)}</td>
                <td>
                  {pduiData?.model?.temperature_data
                    ? pduiData.model.temperature_data[index].name
                    : ""}
                </td>
                <td>
                  <div
                    className={
                      "d-flex align-items-center justify-content-between"
                    }
                  >
                    <div className={"d-flex align-items-center"}>
                      {hasTemperatureReading(temperature) ? (
                        <>
                          <div>{parseFloat(temperature).toFixed(1)}</div>
                          <div className={"ps-2"} style={{ color: "#B4C3E4" }}>
                            °C
                          </div>
                        </>
                      ) : (
                        <div style={{ color: "#B4C3E4" }} title={t('temperature.noReadingHint')}>
                          {t('temperature.noReading')}
                        </div>
                      )}
                    </div>
                    <div
                      style={{
                        backgroundColor: temperatureToHex(temperature),
                        width: "29px",
                        height: "18px",
                        borderRadius: "6px",
                        marginLeft: "8px",
                        marginRight: "15px",
                      }}
                    ></div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
